import { createStore as reduxCreateStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import { parse, stringify } from 'flatted';
import logger from 'redux-logger'

// Reducers
import sideNavWiki from './reducers/sideNavWiki';
import apiDocs from './reducers/apiDocs';
import company from './reducers/company';
import user from './reducers/user';
import contract from './reducers/contract';
import team from './reducers/team';
import application from './reducers/application';
import lookupData from './reducers/lookupData';
import release from './reducers/release';
import diagnostic from './reducers/diagnostic';
import notification from './reducers/notification';
import organization from './reducers/organization'

const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem(_key) {
      return Promise.resolve();
    },
  };
};

export const JSONTransform = createTransform(
  inboundState => stringify(inboundState),
  outboundState => parse(outboundState),
);

const storage = typeof window !== 'undefined' ? createWebStorage('local') : createNoopStorage();

const persistConfig = {
  key: 'devportal',
  storage,
  transforms: [JSONTransform],
  blacklist: ['apiDocs', 'application', 'diagnostic', 'notification']
};

const reducers = combineReducers({
  sideNavWiki,
  apiDocs,
  company,
  user,
  contract,
  team,
  application,
  lookupData,
  release,
  diagnostic,
  notification,
  organization
});

const persistedReducer = persistReducer(persistConfig, reducers);
const middlewares = [thunk];

if (process.env.NODE_ENV == 'development') {
  // middlewares.push(logger) // Uncomment this if you need redux logs
}

const createStore = () => {
  const store = reduxCreateStore(persistedReducer, compose(applyMiddleware(...middlewares)));
  const persistor = persistStore(store);
  return { store, persistor };
};


export default createStore;
